import { IGenerateEventReportParams, IReportListItemDTO, ReportLayout, ReportType } from '../../api/reports.dao';
import ReportsViewModel from '../../components/_events/_manage-event/_reports/reports.viewmodel';
import { TRACKING_EVENTS } from '../../tracking-service/tracking-values';

const REPORT_GENERATION_ENDPOINTS: (vm: ReportsViewModel) => {
    [x: string]: (params: IGenerateEventReportParams, meetingIds?: number[], layoutType?: ReportLayout) => Promise<IReportListItemDTO>;
} = vm => ({
    [ReportType.ATTENDEE_INTERACTIONS_REPORT]: vm.reportsDAO.generateAttendeeInteractionsReport,
    [ReportType.EVENT_INTERACTIONS_REPORT]: vm.reportsDAO.generateEventInteractionsReport,
    [ReportType.EVENT_REGISTRATION_REPORT]: vm.reportsDAO.generateEventRegistrationReport,
    [ReportType.REGISTRANTS_BY_SESSION_REPORT]: vm.reportsDAO.generateRegistrantsBySessionReport
});

const IS_REPORT_GENERATING: (vm: ReportsViewModel) => { [x: string]: boolean } = vm => ({
    [ReportType.ATTENDEE_INTERACTIONS_REPORT]: vm.isGeneratingAttendeesInteractionsReport,
    [ReportType.EVENT_INTERACTIONS_REPORT]: vm.isGeneratingEventInteractionsReport,
    [ReportType.EVENT_REGISTRATION_REPORT]: vm.isGeneratingEventRegistrationReport,
    [ReportType.REGISTRANTS_BY_SESSION_REPORT]: vm.isGeneratingRegistrantsBySessionReport
});

const TRACKING_EVENT_REPORTS: { [x: string]: TRACKING_EVENTS } = {
    [ReportType.ATTENDEE_INTERACTIONS_REPORT]: TRACKING_EVENTS.GENERATE_ATTENDEES_INTERACTIONS_REPORT,
    [ReportType.EVENT_INTERACTIONS_REPORT]: TRACKING_EVENTS.GENERATE_EVENT_INTERACTIONS_REPORT,
    [ReportType.EVENT_REGISTRATION_REPORT]: TRACKING_EVENTS.GENERATE_EVENT_REGISTRATION_REPORT,
    [ReportType.REGISTRANTS_BY_SESSION_REPORT]: TRACKING_EVENTS.GENERATE_REGISTRANTS_BY_SESSION_REPORT
};

export {
    REPORT_GENERATION_ENDPOINTS,
    IS_REPORT_GENERATING,
    TRACKING_EVENT_REPORTS
};
